import { jsx as a } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { LABEL_CONTAINER_CLASS as l, LABEL_CONTAINER_CLASS_LOADING as L, LABEL_CLASS as i } from "./constants.js";
import { TypographyVariant as s } from "../../../../internal/Typography/types.js";
import A from "../../../../internal/Typography/Typography.js";
import f from "classnames";
import { fixedForwardRef as y } from "../../../../../utils/preact/fixedForwardRef.js";
const d = y(
  ({ config: r, i18n: e, isSkeletonVisible: m, className: o, ...t }, p) => /* @__PURE__ */ a(
    "span",
    {
      className: f(l, o, { [L]: m }),
      style: { cursor: "default" },
      ref: p,
      ...t,
      children: r.labelKey && /* @__PURE__ */ a(A, { variant: s.CAPTION, className: i, children: e.get(r.labelKey) })
    }
  )
);
export {
  d as SummaryItemLabel
};
